import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { MaxBrainModuleUserModule } from '../module-user/module-user.module';
import { ModuleManagerListComponent } from './components/list/list.component';
import { ModuleManagersApiService } from './services/module-managers.api-service';
import { ModuleManagersService } from './services/module-managers.service';
import { AddManagersDialogComponent } from './components/dialogs/add-managers-dialog/add-managers-dialog.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { AddProgramManagersDialogComponent } from './components/dialogs/add-program-managers-dialog/add-program-managers-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { EditManagerPermissionsDialogComponent } from './components/dialogs/edit-manager-permissions-dialog/edit-manager-permissions-dialog.component';

@NgModule({
    imports: [
        MaxBrainSharedModule,
        MatCheckboxModule,
        MatMenuModule,
        MatTableModule,
        MatListModule,
        MatCardModule,
        MatIconModule,
        MatFormFieldModule,
        MatToolbarModule,
        MatAutocompleteModule,
        MatInputModule,
        MatButtonModule,
        MatSortModule,
        MaxBrainModuleUserModule,
        MatStepperModule,
        MatPaginatorModule,
        MatChipsModule,
        MatSelectModule,
    ],
    declarations: [ModuleManagerListComponent, AddManagersDialogComponent, AddProgramManagersDialogComponent, EditManagerPermissionsDialogComponent],
    exports: [ModuleManagerListComponent, AddManagersDialogComponent, AddProgramManagersDialogComponent, EditManagerPermissionsDialogComponent],
    providers: [ModuleManagersService],
})
export class MaxBrainModuleManagersModule {
    static forRoot(): ModuleWithProviders<MaxBrainModuleManagersModule> {
        return {
            ngModule: MaxBrainModuleManagersModule,
            providers: [ModuleManagersApiService],
        };
    }
}
